import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Nav } from "reactstrap";
import { Href } from "../../Constants/Constants";
import { MainSidebarListData } from "../../Data/Messenger/Messenger";
import { useAppDispatch, useAppSelector } from "../../ReduxToolkit/Hooks";
import { logout } from "../../ReduxToolkit/Reducers/AuthReducer";
import { setMainSidebarActiveTab, setMainSidebarWidth } from "../../ReduxToolkit/Reducers/Messenger/MainSidebar";
import { Route } from "../../Routers/RouteList";
import { dynamicImage, Image } from "../../Utils";
import SvgIcon from "../CommonComponents/SvgIcon";
import { setTemplateLayoutData } from "../../ReduxToolkit/Reducers/TemplateCustomizerReducers";
import Config from "../../Config/TemplateConfig";

const MainSidebar = () => {
  const dispatch = useAppDispatch();
  const { mainSidebarActiveTab } = useAppSelector((state) => state.mainSidebar);

  useEffect(() => {
    const updateSize = () => dispatch(setMainSidebarWidth(window.innerWidth));
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, [dispatch]);

  return (
    <Nav className="main-nav on custom-scroll">
      <div className="logo-warpper">
        <Link to={Route.Messenger}>
          <Image className="img-fluid inner2" src={dynamicImage("logo/logo-2.png")} alt="footer-back-img" />
        </Link>
      </div>
      <div className="sidebar-main">
        <ul className="sidebar-top">
          {MainSidebarListData.map((item, index) => (
            <li key={index} onClick={() => dispatch(setMainSidebarActiveTab(item.type))}>
              <a className={`header-icon button-effect ${item.class} ${mainSidebarActiveTab === item.type ? "active" : ""}`} href={Href}>
                <SvgIcon className="header-stroke-icon" iconId={item.icon} />
                <SvgIcon className="header-fill-icon" iconId={`fill-${item.icon}`} />
              </a>
            </li>
          ))}
        </ul>
        <ul className="sidebar-bottom">
          <li onClick={() => dispatch(setMainSidebarActiveTab("mode"))}>
            <a className={`header-icon button-effect step3 mode ${mainSidebarActiveTab === "mode" ? "active" : ""}`} href={Href} onClick={() => dispatch(setTemplateLayoutData(Config.sidebar_layout !== "" ? "" : "dark"))}>
              <SvgIcon className="header-stroke-icon" iconId="mode" />
              <SvgIcon className="header-fill-icon" iconId="fill-mode" />
            </a>
          </li>
          <li onClick={() => dispatch(logout())}>
            <a className="header-icon" href={Href}>
              <SvgIcon className="header-stroke-icon" iconId="signOut" />
              <SvgIcon className="header-fill-icon" iconId="fill-signOut" />
            </a>
          </li>
        </ul>
      </div>
    </Nav>
  );
};

export default MainSidebar;
